import { render } from "./PrescriptionDrugs.vue?vue&type=template&id=0bd87165&scoped=true"
import script from "./PrescriptionDrugs.vue?vue&type=script&lang=js"
export * from "./PrescriptionDrugs.vue?vue&type=script&lang=js"

import "./PrescriptionDrugs.vue?vue&type=style&index=0&id=0bd87165&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd87165"]])

export default __exports__